<template>
	<div v-if="tabStyle === 4" class="rn-default-tab style-three">
		<ul class="nav nav-tabs tab-button" role="tablist">
			<li class="nav-item tabs__tab" role="presentation" v-for="(tabMenu, index) in tabData" :key="index">
				<button class="nav-link text-capitalize" :class="{'active': index === activeTab}" :id="`${tabMenu.id}-tab`"
					data-bs-toggle="tab" :data-bs-target="`#${tabMenu.id}`" type="button" role="tab"
					:aria-controls="tabMenu.id" :aria-selected="index === activeTab ? 'true' : 'false'"
					@click="handleTabClick(index)">
					{{ tabMenu.text }}
				</button>
			</li>
		</ul>

		<div class="rn-tab-content tab-content">
			<div class="tab-pane fade" :class="{'show active': index === activeTab}" :id="content.id" role="tabpanel"
				:aria-labelledby="`${content.id}-tab`" v-for="(content, index) in tabData" :key="index">
				<div class="inner">
					<div class="row align-items-center row--30">
						<div v-if="index == 1" class="col-lg-4">
							<div class="section-title">
								<h4 class="title">{{content.menuTitle}}</h4>
								<p>
									{{content.menuContext}}
								</p>
								<div class="read-more">
									<a class="btn-default btn-small" href="/about-us">查看详细</a>
								</div>
							</div>
						</div>
						
						<div
							:class="index == 1 ? 'col-lg-8 mt_md--30 mt_sm--30' : 'col-lg-12 mt_md--30 mt_sm--30'">
							<div class="row row--15 mt_dec--30 service-wrapper">
								<div :class="content.dataList.length === 2 ? 'col-lg-6 col-md-6 col-sm-6 col-12' : 'col-lg-4 col-md-6 col-sm-6 col-12'"
									v-for="(service, index) in content.dataList" :key="`service-${index}`">
									<div class="card-box card-style-1 text-left">
										<div class="inner">
											<div class="image">
												<router-link :to="service.toUrl">
													<img :src="require(`@/assets/images/edge/Active/${service.image}`)" alt="Card Images">
												</router-link>
											</div>
											<div class="content">
												<h4 class="title mb--20">
													<router-link :to="service.toUrl">
														{{ service.title }}
													</router-link>
												</h4>
												<p class="description b1 color-gray mb--0">
													<span v-html="service.description"></span>
												</p>
												<router-link class="btn-default btn-small" :to="service.toUrl">
													查看详细
												</router-link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: 'Tab',
		props: {
			tabData: {},
			tabStyle: {
				type: Number,
				default: 1
			},
			value: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				activeTab: this.value
			}
		},
		watch: {
			value(val) {
				this.activeTab = val;
			}
		},
		methods: {
			handleTabClick(index) {
				this.activeTab = index;
				this.$emit('input', index);
				this.$emit('tab-change', index);
			}
		}
	}
</script>
